import { motion } from "framer-motion";
import { EASE } from "@/lib/site";

export const Reveal = ({ children, delay = 0, y = 28, className, ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.12 }}
    transition={{ duration: 0.8, ease: EASE, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines, delay = 0.1, className }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={line} className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
        <motion.span
          className="block"
          initial={{ y: "108%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1, ease: EASE, delay: delay + i * 0.12 }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);
